import React, { useState } from "react";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const statusColor = {
  Active: "success",
  Attention: "warning",
  Critical: "error",
};

export default function MachineListTable() {
  const [equipmentType, setEquipmentType] = useState("Batching Plant");
  const [dateRange, setDateRange] = useState("Last 30 Days");
  const [loading, setLoading] = React.useState(false);
  const [machineDetails, setMachineDetails] = useState([]);

  const navigate = useNavigate();

  const getMachineDetails = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token"); // or sessionStorage

      const res = await axios.get(
        "https://iot-api.elantristechnologies.com/api/BatchingPlant/Get_MachineDetails",
        {
          headers: {
            Authorization: `Bearer ${token}`, // 👈 token header
            "Content-Type": "application/json",
          },
        },
      );

      if (res.data.status == "1") {
        setMachineDetails(
          res.data.data.map((item) => ({
            cust_code: item.cust_code,
            mac_id: item.mac_id,
            prod_id: item.prod_id,
            eqp_id: item.eqp_id,
            eqp_group_id: item.eqp_group_id,
            mac_type: item.mac_type,
            mac_sl: item.mac_sl,
            mac_name: item.mac_name,
            imei: item.imei,
            iot_type: item.iot_type,
            inst_date: item.inst_date,
            act_date: item.act_date,
            expiry_date: item.expiry_date,
          })),
        );

        // 👉 mac_id & mac_type only store in localStorage
        const macInfo = res.data.data.map((m) => ({
          mac_id: m.mac_id,
          mac_type: m.mac_type,
          prod_id: m.prod_id,
        }));

        localStorage.setItem("machineMacInfo", JSON.stringify(macInfo));
      } else {
        alert(res.data.msg);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getMachineDetails();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      {/* Select Bar */}

      <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          fontSize={14}
          mb={0.5}
          sx={{ fontFamily: "Poppins, sans-serif", fontSize: "1.5rem" }}
        >
          Batching Plants
        </Typography>
        {/* <FormControl fullWidth size='small' sx={{ width: 300 }}>
          <Select
            value={equipmentType}
            onChange={(e) => setEquipmentType(e.target.value)}
            sx={{
              fontFamily: "Poppins, sans-serif",
            }}
          >
            <MenuItem
              value='Batching Plant'
              sx={{ fontFamily: "Poppins, sans-serif" }}
            >
              Model 1
            </MenuItem>

            <MenuItem
              value='Concrete Mixer'
              sx={{ fontFamily: "Poppins, sans-serif" }}
            >
              Model 2
            </MenuItem>

            <MenuItem
              value='Excavator'
              sx={{ fontFamily: "Poppins, sans-serif" }}
            >
              Model 3
            </MenuItem>
          </Select>
        </FormControl> */}
      </Grid>

      {/* Table */}
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ fontFamily: "Poppins, sans-serif" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {[
                "Mac Type",
                "Mac SI No",
                "Machine Name",
                "IMEI",
                "Iot Type",
                "Instal Date",
                "Active Date",
                "Expiry Date",
                "Location",
              ].map((head) => (
                <TableCell
                  align={head == "Status" ? "center" : ""}
                  key={head}
                  sx={{
                    fontWeight: 600,
                    color: "#6b7280",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {machineDetails.map((row, index) => (
              <TableRow
                key={index}
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/Dashboard");
                  sessionStorage.setItem("selectnav1", "Dashboard");
                }}
              >
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {row.mac_type}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {row.mac_sl}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {row.mac_name}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {row.imei}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {row.iot_type}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {dayjs(row.inst_date).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {dayjs(row.act_date).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  {dayjs(row.expiry_date).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  -
                </TableCell>

                {/* <TableCell
                  align='center'
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    color: "#2e2e2e",
                    paddingTop: "9px",
                    paddingBottom: "9px",
                  }}
                >
                  <Chip
                    label={row.status}
                    size='small'
                    color={statusColor[row.status]}
                    sx={{
                      width: 100,
                      fontWeight: 500,
                      fontFamily: "Poppins, sans-serif",
                    }}
                  />
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
